import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <path
      d="M11 7H2C0.9 7 0 6.1 0 5V2C0 0.9 0.9 0 2 0H11V7ZM2 5H9V2H2V5ZM13 16H2C0.9 16 0 15.1 0 14V11C0 9.9 0.9 9 2 9H13V16ZM2 14H11V11H2V14ZM20 5H18L20 0H13V7H15V16L20 5ZM2.8 13.2H4.3V11.7H2.8V13.2ZM2.8 4.2H4.3V2.8H2.8V4.2Z"
      fill="black"
      fillOpacity="0.6"
    />
  ),
  'InlineQuizIcon',
  '0 0 20 16'
);
